export const errors = {
    '401': 'פרטי הזיהוי שגויים',
    '500': 'ישנה בעיית התחברות לשרת',
    '403': 'גישה אסורה',
    '411': 'חסרים פרמטרים לקריאה זו'
}
